class ECatalogModal extends HTMLElement {
  connectedCallback() {
    // Escape header stacking context — header uses transform animation which
    // makes it a containing block for position:fixed children (CSS spec §9.3).
    // Moving to body ensures position:fixed is viewport-relative.
    if (this.parentNode !== document.body) {
      document.body.appendChild(this);
      return; // connectedCallback fires again after move
    }

    this.querySelectorAll('[data-ecatalog-close]').forEach(el => {
      el.addEventListener('click', () => this.close());
    });

    const wrapper = this.querySelector('.ecatalog-modal__wrapper');
    if (wrapper) {
      wrapper.addEventListener('click', e => e.stopPropagation());
    }

    document.addEventListener('keydown', this._onKeyDown = (e) => {
      if (e.key === 'Escape') this.close();
    });

    if (this.hasAttribute('data-auto-open') && !sessionStorage.getItem('ecatalog-dismissed')) {
      const delay = parseInt(this.dataset.autoOpenDelay || '3') * 1000;
      this._autoOpenTimer = setTimeout(() => this.open(), delay);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._onKeyDown);
    clearTimeout(this._autoOpenTimer);
  }

  open() {
    this.removeAttribute('hidden');
    document.body.classList.add('ecatalog-modal-open');
    this.querySelector('.ecatalog-modal__close')?.focus();
  }

  close() {
    this.setAttribute('hidden', '');
    document.body.classList.remove('ecatalog-modal-open');
    sessionStorage.setItem('ecatalog-dismissed', '1');
  }
}

customElements.define('ecatalog-modal', ECatalogModal);

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-ecatalog-open]');
  if (trigger) {
    const modal = document.getElementById(trigger.dataset.ecatalogOpen);
    if (modal) modal.open();
  }
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.ecatalog-modal__download-btn');
  if (!btn) return;
  e.preventDefault();
  const url = btn.href;
  const filename = url.split('/').pop().split('?')[0];
  fetch(url)
    .then((r) => r.blob())
    .then((blob) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    })
    .catch(() => window.open(url, '_blank'));
});
